// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  captchaSiteKey: '6Lc7zegUAAAAAEWnFULjQ5qmdZEWVBvhPWLu9jP5',
  elasticPassword: "A20D724666502CFCC35AEC50114EEA273EBB",
  sendInBlueKey: "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"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
